<template>
  <div class="editor">
    <div class="column is-half is-offset-one-quarter has-text-left">
      <b-field label="Заголовок" :class="{'is-danger': errors.has('partner-title') }">
        <b-input 
          v-model='computedPartner.title'
          v-validate="'required'"
          name="partner-title"
        />
      </b-field>
      <b-checkbox v-model="computedPartner.showTitle" class="mt-10">
        Показывать заголовок
      </b-checkbox>
      <b-field label="Ссылка" class="mt-10">
        <b-input v-model='computedPartner.url'></b-input>
      </b-field>
      <b-field label="Логотип" class="logo-wrapper">
        <img :src="imageUrl" v-if="imageUrl" class="logo">
        <span class="button-wrapper" @click="$refs.loadLogoInput.click()" v-if="!imageUrl">
          <a class="button is-info">+</a>Добавить
        </span>
        <span class="button-wrapper" @click="removeImage" v-else>
          <a class="button is-danger">-</a>Удалить
        </span>
        <input type="file" @change='loadLogo' hidden ref="loadLogoInput"/>
      </b-field>
      <button class="button is-fullwidth" @click="save" :disabled="disabled">СОХРАНИТЬ</button>
      <router-link :to="{ name: 'Partners' }" class="button is-fullwidth">ОТМЕНИТЬ</router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'PartnerEditor',
  data () {
    return {
      imageSrc: '',
      disabled: false,
      computedPartner: {
        id: 'new',
        url: '',
        title: '',
        logo: {
          image: '',
          orientation: ''
        },
        showTitle: true
      }
    }
  },
  computed: {
    ...mapState(['partner']),
    imageUrl () {
      const originalLogo = this.computedPartner && this.computedPartner.logo ? this.computedPartner.logo.image : ''
      return this.imageSrc || (originalLogo ? `/upload/photos/${originalLogo}` : '')
    }
  },
  created () {
    const partnerId = this.$route.params.id
    if (partnerId !== 'new') {
      this.getPartner(partnerId)
    }
  },
  watch: {
    partner (value) {
      this.computedPartner = deepcopy(value)
    }
  },
  methods: {
    ...mapActions(['getPartners', 'getPartner', 'addPartner', 'updatePartner']),
    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true
          let data = new FormData()
          data.append('data', JSON.stringify(this.computedPartner))
          data.append('image', this.computedPartner.logo.image)
          const handleMethod = this.computedPartner.id === 'new' ? this.addPartner : this.updatePartner
          handleMethod(data)
          .then(() => {
            this.disabled = false
            this.$router.push({ name: 'Partners' })
            this.$toast.open({
              message: 'Сохранено'
            })
          })
        }
      })
    },
    removeImage () {
      this.imageSrc = ''
      this.computedPartner.logo = {
        orientation: '',
        image: ''
      }
      this.$refs.loadLogoInput.value = ''
    },
    loadLogo (e) {
      const reader = new FileReader()
      reader.onload = e => {
        this.imageSrc = e.target.result
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          this.computedPartner.logo.orientation = (image.width / image.height <= 2.5) ? 'vertical' : 'horizontal'
        }
      }
      this.computedPartner.logo.image = e.target.files[0]
      reader.readAsDataURL(e.target.files[0])
    }
  }
}
</script>

<style scoped>
.main-content .logo-wrapper {
  display: block !important;
}
.logo {
  display: block;
  max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// Editor.vue?14cdb17e